// First-week page for new Dream Team members.

export const ONBOARDING = {
  intro:"New to the Dream Team? This is your first-week page. Read it once, work the checklist, and you're moving.",
  steps:[
    {
      t:"Read Who We Are",
      d:"The vision, the mission, and all 14 Culture Codes — the heartbeat of the house.",
      page:"culture"
    },
    {
      t:"Walk the SERVE phase on myTRiBE+",
      d:"TribeTrack 101 & 102. Our story, our codes, your invitation.",
      page:"tribe"
    },
    {
      t:"Sign the Code of Conduct & Character Agreement",
      d:"Our biblical standard for how leaders carry themselves.",
      id:"onb-sign-the-code-of-conduct-and-character-agr"
    },
    {
      t:"Sign the Confidentiality Agreement",
      d:"Honor discretion — Code 13 in writing.",
      id:"onb-sign-the-confidentiality-agreement"
    },
    {
      t:"Get in the chat",
      d:"Join CLLXTV HQ on GroupMe so you never miss a word.",
      id:"onb-get-in-the-chat"
    }
  ],
  liveBy:[
    {
      h:"Honor leadership",
      p:"Deal with conflict directly and privately; support decisions publicly. No negative talk about staff or volunteers."
    },
    {
      h:"Represent well",
      p:"Online and in the room — you carry CLLXTV's name publicly."
    },
    {
      h:"Character matters",
      p:"The agreement covers our biblical standards for conduct. Who you are when nobody's watching."
    }
  ],
  library:[
    {
      tag:"DOC",
      title:"Code of Conduct & Character Agreement",
      id:"onb-code-of-conduct-and-character-agreement"
    },
    {
      tag:"DOC",
      title:"Confidentiality Agreement",
      id:"onb-confidentiality-agreement"
    },
    {
      tag:"FOLDER",
      title:"Onboarding 2026 (folder)",
      id:"onb-onboarding-2026-folder"
    },
    {
      tag:"LINK",
      title:"Join CLLXTV HQ on GroupMe",
      id:"onb-join-cllxtv-hq-on-groupme"
    }
  ]
};
